import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faSearch } from '@fortawesome/free-solid-svg-icons';
import ParticleNetwork from '../components/ParticleNetwork';
import { productCategories, products } from '../data/products';
import '../styles/ProductsPage.css';

const ProductsPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredProducts = products.filter((product) => {
    const matchesCategory = activeCategory === 'all' || product.category === activeCategory;
    const normalizedSearch = searchTerm.toLocaleLowerCase('tr-TR');
    const matchesSearch =
      product.name.toLocaleLowerCase('tr-TR').includes(normalizedSearch) ||
      product.description.toLocaleLowerCase('tr-TR').includes(normalizedSearch);

    return matchesCategory && matchesSearch;
  });

  return (
    <div className="products-page">
      <section className="products-hero">
        <ParticleNetwork />
        <div className="container">
          <motion.div
            className="hero-centered-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="breadcrumbs">
              <Link to="/">Ana Sayfa</Link>
              <span className="separator">/</span>
              <span className="current">Ürünlerimiz</span>
            </div>

            <div className="hero-main">
              <h1 className="hero-title">Ürünlerimiz</h1>
              <div className="hero-accent-line"></div>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="products-controls">
        <div className="container">
          <div className="controls-wrapper">
            <div className="category-tabs">
              {productCategories.map((category) => (
                <button
                  key={category.id}
                  className={`tab-btn ${activeCategory === category.id ? 'active' : ''}`}
                  onClick={() => setActiveCategory(category.id)}
                >
                  {category.name}
                </button>
              ))}
            </div>

            <div className="search-wrapper">
              <FontAwesomeIcon icon={faSearch} />
              <input
                type="text"
                placeholder="Ürün veya özellik ara..."
                value={searchTerm}
                onChange={(event) => setSearchTerm(event.target.value)}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="products-grid-section">
        <div className="container">
          <motion.div className="products-grid" initial="hidden" animate="visible" layout>
            <AnimatePresence mode="popLayout">
              {filteredProducts.length > 0 ? (
                filteredProducts.map((product) => (
                  <motion.article
                    key={product.id}
                    className="product-card"
                    layout
                    initial={{ opacity: 0, scale: 0.96 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.96 }}
                    whileHover={{ y: -10 }}
                  >
                    <Link to={`/products/${product.slug}`} className="product-card-link-wrapper">
                      <div className="product-image-box">
                        <img src={product.image} alt={product.name} />
                        <div className="card-overlay">
                          <span>Detayları Gör</span>
                          <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                      </div>
                      <div className="product-card-body">
                        <span className="product-cat-tag">
                          {productCategories.find((category) => category.id === product.category)?.name}
                        </span>
                        <h3>{product.name}</h3>
                        <p>{product.description.substring(0, 96)}...</p>
                      </div>
                    </Link>
                  </motion.article>
                ))
              ) : (
                <motion.div className="no-results" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                  <p>Aradığınız kriterlere uygun ürün bulunamadı. Lütfen farklı bir arama yapın.</p>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
